import { createRouter, createWebHistory } from 'vue-router'
import Locations from '../views/Locations.vue'
import AddEnergySite from '../views/AddEnergySite.vue'
import EditEnergySite from '../views/EditEnergySite.vue'
import Login from '../views/Login.vue'
// import Test from '../views/test.vue'
import Register from '../views/Register.vue'
import Companies from '../views/Companies.vue'
import PaymentTypes from '../views/PaymentTypes.vue'
import Dashboard from '../views/Dashboard.vue'
import Documents from '../views/Documents.vue' 
import Financed from '../views/Financed.vue'
import store from "@/store";
import FinancedSources from '../views/FinancedSources.vue'
import ReceivingSupportCompanies from '../views/ReceivingSupportCompanies.vue'
import ReceivingAgreements from '../views/ReceivingAgreements.vue'
import ReceivingSupportCompanyFinancedOverview from '../views/ReceivingSupportCompanyFinancedOverview.vue'
import DataConnections from '../views/DataConnections.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import BackToLogin from '../views/BackToLogin.vue'
import Changepassword from '../views/Changepassword.vue'
import PasswordChanged from '../views/PasswordChanged.vue'
import DocumentGeneration from '../views/DocumentGeneration.vue'
import NewDocumentGeneration from '../views/NewDocumentGeneration.vue'
import CompanyCommunication from '../views/CompanyCommunication.vue'
import RefillPointsOverview from '../views/RefillPointsOverview.vue'

const authGuard = (to, from, next) => {
  //console.log('ROUTER authGuard###################################');
  if (store.getters.isAuthenticated) {
    next();
  } else {
    store.dispatch("logout")
    //router.push({ name: 'Login' })
    next({ name: 'Login' })
  }
};

/*
const getTranslate = (key) => {
  //console.log('ROUTER ################################### GetTranslate: ' + key);
  //console.log(store);
  //store.getters.getTranslate(key)
} 
*/

const routes = [
  {
    path: '/OldNekajRoot',
    name: 'home',
    component: Locations,
    beforeEnter: authGuard 
  }, 
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    beforeEnter: authGuard,
    props: true
  },   
  {
    path: '/CDashboard/:companyid',
    name: 'CDashboard',
    component: Dashboard,
    beforeEnter: authGuard,
    props: true
  },    
  {
    path: '/locations/:viewcompanyid?/:viewedCompanName?',
    name: 'EnergySites',
    component: Locations,
    beforeEnter: authGuard,
    props: true
  },   
  {
    path: '/addEnergySite',
    name: 'AddEnergySite',
    component: AddEnergySite,
    beforeEnter: authGuard
  },
  {
    path: '/EditEnergySite/:id/:viewedCompanName?',
    name: 'EditEnergySite',
    component: EditEnergySite,
    beforeEnter: authGuard,
    props: true
  },  
  {
    path: '/login',
    name: 'Login',
    component: Login
  },  
  {
    path: '/register',
    name: 'Register',
    component: Register
  }, 
  {
    path: '/ForgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  }, 
  {
    path: '/Changepassword',
    name: 'Changepassword',
    component: Changepassword
  },
  {
    path: '/PasswordChanged',
    name: 'PasswordChanged',
    component: PasswordChanged
  },
  {
    path: '/BackToLogin',
    name: 'BackToLogin',
    component: BackToLogin
  },
  {
    path: '/Companies/:approved',
    name: 'Companies',
    component: Companies,
    props: true
  },  
  {
    path: '/PaymentTypes',
    name: 'PaymentTypes',
    component: PaymentTypes,
    beforeEnter: authGuard,
  },
  {
    path: '/Financed',
    name: 'Financed',
    component: Financed,
    beforeEnter: authGuard,
  },
  {
    path: '/FinancedSources',
    name: 'FinancedSources',
    component: FinancedSources,
    beforeEnter: authGuard,
  },
  {
    path: '/ReceivingSupportCompanies/:financedId?',
    name: 'ReceivingSupportCompanies',
    component: ReceivingSupportCompanies,
    beforeEnter: authGuard,
    props: true
  },
  {
    path: '/ReceivingAgreements/:financedId/:companyId',
    name: 'ReceivingAgreements',
    component: ReceivingAgreements,
    beforeEnter: authGuard,
    props: true
  },
  {
    path: '/ReceivingSupportCompanyFinancedOverview/:companyId',
    name: 'ReceivingSupportCompanyFinancedOverview',
    component: ReceivingSupportCompanyFinancedOverview,
    beforeEnter: authGuard,
    props: true
  },
  {
    path: '/Documents',
    name: 'Documents',
    component: Documents,
    beforeEnter: authGuard,
  },
  {
    path: '/DocumentGeneration',
    name: 'DocumentGeneration',
    component: DocumentGeneration,
    beforeEnter: authGuard,
  },
  {
    path: '/NewDocumentGeneration',
    name: 'NewDocumentGeneration',
    component: NewDocumentGeneration,
    beforeEnter: authGuard,
  },
  {
    path: '/CompanyCommunication',
    name: 'CompanyCommunication',
    component: CompanyCommunication,
    beforeEnter: authGuard,
  },
  {
    path: '/RefillPointsOverview',
    name: 'RefillPointsOverview',
    component: RefillPointsOverview,
    beforeEnter: authGuard,
  },
  {
    path: '/DataConnections/:companyid',
    name: 'DataConnections',
    component: DataConnections,
    beforeEnter: authGuard,
    props: true
  }   
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
